module.exports = __webpack_public_path__ + "img/caso1.a0b06a0a.png";